import React from 'react';
import { useThemeStore, useViewerModeStore } from '../../stores';
import { useAuthStore } from '../../stores/useAuthStore';
import { useSeasonsStore } from '../../stores/useSeasonsStore';
import { AdminMode } from '../admin/AdminMode';
import Button from '../ui/Button/Button';
import './ScrapbookFooter.css';

const ScrapbookFooter: React.FC = () => {
    const { theme, toggleTheme } = useThemeStore();
    const { mode, toggleMode, isPersonalAvailable } = useViewerModeStore();
    const logout = useAuthStore((state) => state.logout);
    const clearData = useSeasonsStore((state) => state.clearData);
    const handleSignOut = async () => {
        await logout();
        clearData();
    };

    const nextModeName = mode === 'personal' ? 'family' : 'personal';
    const nextModeButtonText = mode === 'personal' ? '👪 Family' : '🔒 Personal';

    // A family-only credential (the TV) can never switch to personal, nor sign out:
    // DELETE /auth-session is admin-only.
    let viewerModeLabel = '🔒 Personal unavailable';
    let viewerModeAriaLabel = 'Personal view unavailable on this device';
    if (isPersonalAvailable) {
        viewerModeLabel = `${nextModeButtonText} View`;
        viewerModeAriaLabel = `Switch to ${nextModeName} view`;
    }

    return (
        <footer className="footer" aria-label="Site Footer">
            <div className="footer-content">
                <div className="footer-button-container">
                    <Button
                        variant="theme-toggle"
                        onClick={toggleTheme}
                        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
                        data-testid="theme-toggle"
                    >
                        {theme === 'dark' ? '☀️ Light' : '🌙 Dark'} Theme
                    </Button>
                    <Button
                        variant="theme-toggle"
                        onClick={toggleMode}
                        disabled={!isPersonalAvailable}
                        aria-label={viewerModeAriaLabel}
                        data-testid="viewer-mode-toggle"
                    >
                        {viewerModeLabel}
                    </Button>
                    <AdminMode />
                    {isPersonalAvailable && (
                        <Button variant="theme-toggle" onClick={handleSignOut} aria-label="Sign out">Sign out</Button>
                    )}
                </div>
                <span className="footer-text">
                    &copy; {new Date().getFullYear()} ys520. All rights reserved.
                </span>
            </div>
        </footer>
    );
};

export default ScrapbookFooter;
